import { CSSProperties, ReactNode } from 'react';
import Image from 'next/image';

import { Box, Flex, Heading, StyleProps, Text } from '@chakra-ui/react';

import { HeroLayout } from '~/features/experiments/ab_plp_redesign_2025/components/hero-layout';

type AiMarketerHeroBackgroundImage = {
  src: string;
  objectPosition?: CSSProperties['objectPosition'];
  style?: CSSProperties;
};

type AiMarketerHeroProps = {
  title: string;
  description: string;
  backgroundColor: StyleProps['bgColor'];
  backgroundImages: {
    mobile: AiMarketerHeroBackgroundImage;
    desktop: AiMarketerHeroBackgroundImage;
  };
  backgroundImageOverlayGradient?: StyleProps['bgGradient'];
  heroTextMaxWidth?: StyleProps['maxWidth'];
  ctaSlot: ReactNode;
};

export function AiMarketerHero({
  title,
  description,
  backgroundColor,
  backgroundImages,
  backgroundImageOverlayGradient,
  heroTextMaxWidth,
  ctaSlot,
}: AiMarketerHeroProps) {
  return (
    <HeroLayout
      backgroundImageOverlayGradient={backgroundImageOverlayGradient}
      bgColor={backgroundColor}
      ctaSlot={ctaSlot}
      backgroundImageSlot={
        <>
          <Box display={{ base: 'block', md: 'none' }} inset={0} position='absolute'>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src={backgroundImages.mobile.src}
              style={{
                objectFit: 'cover',
                objectPosition: backgroundImages.mobile.objectPosition ?? 'center',
                ...backgroundImages.mobile.style,
              }}
              fill
              priority
            />
          </Box>
          <Box display={{ base: 'none', md: 'block' }} inset={0} position='absolute'>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src={backgroundImages.desktop.src}
              style={{
                objectFit: 'cover',
                objectPosition: backgroundImages.desktop.objectPosition ?? 'center',
                ...backgroundImages.desktop.style,
              }}
              fill
              priority
            />
          </Box>
        </>
      }
      textAndCtaContainerProps={{
        gap: { base: '24px', md: '40px' },
      }}
      textContentSlot={
        <Flex
          flexDirection='column'
          gap={{ base: '16px', md: '24px' }}
          maxWidth={heroTextMaxWidth ?? { base: '100%', md: '600px' }}
          pt={{
            base: '120px',
            md: '0',
          }}
        >
          <Heading
            as='h1'
            color='white'
            letterSpacing='0.01em'
            size={{ base: 'mobile-heading-2', md: 'heading-2' }}
            whiteSpace='pre-line'
          >
            {title}
          </Heading>
          <Text color='gray.300' fontSize='lg' lineHeight='lg' maxWidth={{ base: '100%', md: '520px' }}>
            {description}
          </Text>
        </Flex>
      }
    />
  );
}
